<template>
  <modal-box class="message-modal" :title="message.title">
    <template #body>
      <div class="content">
        <p class="content__secondary">
          {{ message.description }}
        </p>
      </div>
      <div class="ctas">
        <text-link class="close-link" @click="closeModal"
          >Close window</text-link
        >
      </div>
    </template>
  </modal-box>
</template>

<script>
import TextLink from "@/components/atoms/TextLink";
import ModalBox from "@/components/molecules/ModalBox";

export default {
  name: "MessageModal",
  components: {
    TextLink,
    ModalBox,
  },
  data() {
    return {};
  },
  computed: {
    message() {
      return this.$store.state.message.data;
    },
  },
  methods: {
    closeModal() {
      this.$store.dispatch("closeModal");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.message-modal {
  padding-left: 28px;
  padding-right: 28px;
}
.deposit {
  display: grid;
  font-weight: 600;
  grid-gap: 24px 16px;
  grid-template-columns: 1fr auto;

  @include media(pc) {
    font-size: 2.7rem;
  }
  @include media(sp) {
    font-size: 2.2rem;
  }
  .label {
    grid-row: 1;
    grid-column: 1 / 3;
  }
  .num {
    font-weight: 700;
    grid-column: 1;
    text-align: right;
  }
  .unit {
    grid-column: 2;
  }
}
.close-link {
  margin-top: 24px;

  @include media(pc) {
    font-size: 1.7rem;
  }
  @include media(sp) {
    font-size: 1.4rem;
  }
}

.content {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  &__primary {
    // color: #86d3fd;
    color: #00a4b2;
    margin-bottom: 20px;
    font-size: 1.6rem;
  }
  &__secondary {
    font-size: 1.6rem;
  }
}
.ctas {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>